var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41 18.76h4.94a.4.4 0 01.4.4v2.07a.4.4 0 01-.4.4H6.41a.4.4 0 01-.4-.4v-2.07a.4.4 0 01.4-.4zm0-6h10.67a.4.4 0 01.4.4v2.07a.4.4 0 01-.4.4H6.41a.4.4 0 01-.4-.4v-2.07a.4.4 0 01.4-.4zm0-6h14.54a.4.4 0 01.4.4v2.07a.4.4 0 01-.4.4H6.41a.4.4 0 01-.4-.4V7.16a.4.4 0 01.4-.4zM6.36.93h20.19a.4.4 0 01.4.4V3.4a.4.4 0 01-.4.4H6.36a.4.4 0 01-.4-.4V1.33a.4.4 0 01.4-.4zm23.21 23.66H2.82V.34A.36.36 0 002.49 0H.33A.36.36 0 000 .34v26.74a.36.36 0 00.33.34h29.24a.36.36 0 00.33-.34v-2.16a.36.36 0 00-.33-.33z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarHorizontal);
export default __webpack_public_path__ + "static/media/bar-horizontal.c3e7ae47.svg";
export { ForwardRef as ReactComponent };